import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import '../styles/Infrastructure.css';

const Infrastructure = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="infrastructure" className="infrastructure-section">
      <div className="section-container">
        <h2>{t.infraTitle}</h2>
        <p className="section-subtitle">{t.infraSubtitle}</p>
        
        <div className="infra-features">
          <div className="infra-feature">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" fill="none">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7v10c0 2 1 3 3 3h10c2 0 3-1 3-3V7c0-2-1-3-3-3H7c-2 0-3 1-3 3zM16 3v4M8 3v4M3 11h18"></path>
              </svg>
            </div>
            <div className="feature-content">
              <h3>{t.infra1Title}</h3>
              <p>{t.infra1Desc}</p>
              <ul className="feature-list">
                <li>Finance-aware schema & dashboards</li>
                <li>Deterministic financial state tracking</li>
                <li>High-performance querying & monitoring</li>
              </ul>
            </div>
          </div>
          
          <div className="infra-feature">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" fill="none">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"></path>
              </svg>
            </div>
            <div className="feature-content">
              <h3>{t.infra2Title}</h3>
              <p>{t.infra2Desc}</p>
              <ul className="feature-list">
                <li>ISO-20022 & ISO-8583 parsers</li>
                <li>Banking protocol intelligence</li>
                <li>Validators, encoders, dispatchers</li>
              </ul>
            </div>
          </div>
          
          <div className="infra-feature">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" fill="none">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
            </div>
            <div className="feature-content">
              <h3>{t.infra3Title}</h3>
              <p>{t.infra3Desc}</p>
              <ul className="feature-list">
                <li>Financial intelligence & categorization</li>
                <li>Time machine & historical state replay</li>
                <li>Institutional visualization & access control</li>
              </ul>
            </div>
          </div>
          
          <div className="infra-feature">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" fill="none">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path>
              </svg>
            </div>
            <div className="feature-content">
              <h3>{t.infra4Title}</h3>
              <p>{t.infra4Desc}</p>
              <ul className="feature-list">
                <li>Exchanges & clearinghouses</li>
                <li>Public data APIs</li>
                <li>Institutional access control</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Infrastructure;